import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { AuthService } from 'app/core/auth/auth.service';
import { Subject, takeUntil, throwError } from 'rxjs';
import { EncryptdecryptService } from 'app/shared/services/encryptdecrypt.service';
import { User } from 'app/core/user/user.types';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { UserService } from 'app/modules/user/user.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector: 'classicenfinity-layout',
    templateUrl: './classicenfinity.component.html'
})
export class ClassicEnfinityLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    enfinityNavigation: FuseNavigationItem[];
    currentUser: any;
    roleFrom: FormGroup ;
    user: User;
    partnerName: string = "";
    encryptstring: string = "";
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    @Input() showAvatar: boolean = true;

    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private EncrDecr: EncryptdecryptService,       
        private _authService: AuthService,
        private _userService: UserService,
        private _formBuilder: UntypedFormBuilder,
        private oauthService: OAuthService,
        private _cdr: ChangeDetectorRef  // ADD THIS
    ) {
    }

    get currentYear(): number {
        return new Date().getFullYear();
    }

    ngOnInit(): void {
        console.log("JSON.parse(this._authService.accessUser);", JSON.parse(this._authService.accessUser));
        
        const claims = this.oauthService.getIdentityClaims();
        if (!claims || !claims['sub']) {
            throwError(() => new Error('PE ID (sub) not found in token claims.'));
        }
        const name = claims['name'];

        this.user = JSON.parse(this._authService.accessUser);  
        this.roleFrom = this._formBuilder.group({
            UserID: [this.user.id]
        });
        this.partnerName = name;
        console.log("user.partnerName", this.user.user_PartnerName);

        // WRAP THE HTTP CALL IN setTimeout
        setTimeout(() => {
            this._userService.GetRoleDataById(this.roleFrom.value).subscribe(
                (res: any) => {
                    console.log("menu bind-->", res);
                    this.navigation = res;
                    
                    // TRIGGER CHANGE DETECTION AFTER DATA IS SET
                    this._cdr.detectChanges();
                },
                (error) => {
                    console.log(error);
                }
            );
        }, 0);

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    toggleNavigation(name: string): void {
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if (navigation) {
            navigation.toggle();
        }
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    changepassword(): void {
        this._router.navigate(['/change-password']);
    }

    userdetail(id: any): void {
        this.EncrDecr.getEncryptid(id).subscribe(
            (res: any) => {
                this.encryptstring = res.encryptedText;
                if (this.encryptstring != null && this.encryptstring != '') {
                    this._router.navigate(['/user/userdetail', this.encryptstring]);
                }
            })
    }

    partnerdetail(id: any): void {
        this.EncrDecr.getEncryptid(id).subscribe(
            (res: any) => {
                this.encryptstring = res.encryptedText;
                if (this.encryptstring != null && this.encryptstring != '') {
                    this._router.navigate(['/user/userdetail', this.encryptstring]);
                }
            })
    }

    Onimage() {
        this._router.navigate(['/dashboards/customer'])
    }
}